module.exports = "https://deal-img.imgix.net/consumer/og-image.4086adb8.jpg";